module.exports = __webpack_public_path__ + "static/media/piper-tool-right.e22364d1.svg";